export default {
  employees: '',
  birthdays: '',
  contactMessagesWebSite: '',
  paychecks: '',
  scales: '',
  income_taxes: '',
}
